import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';

const KeywordIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 27' fill='none'>
        <path
          d='M4.5 24.75h15.75a2.25 2.25 0 002.25-2.25V7.875L16.875 2.25H6.75A2.25 2.25 0 004.5 4.5v6.75'
          stroke='currentColor'
          strokeWidth={2.02}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.75 2.25v4.5A2.25 2.25 0 0018 9h4.5M4.5 20.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM11.25 11.25l-5.063 5.063M10.125 12.375L11.25 13.5'
          stroke='currentColor'
          strokeWidth={2.02}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};

export default memo(KeywordIcon);
